import { RewardGroupDTOGroup } from '../service/api/aok-rest-api';
import { AokCardViewModel } from './aok-card-view-model';

export class RewardGroupViewModel extends AokCardViewModel{
    group?: RewardGroupDTOGroup | undefined;
}